export default {
  'projectSettings.detail.title': '项目详情',
  'projectSettings.detail.subtitle': '维护当前项目的基础信息',
  'projectSettings.detail.basicInfo': '基础信息',
  'projectSettings.detail.unsaved': '有未保存修改',
  'projectSettings.detail.refresh': '刷新',
  'projectSettings.detail.edit': '修改项目',
  'projectSettings.detail.noContext': '当前页面未识别到项目上下文',
  'projectSettings.detail.loadError': '项目详情加载失败',
  'projectSettings.detail.loadErrorHint': '请检查网络连接后重试。',
  'projectSettings.detail.retry': '重试',
  'projectSettings.detail.logoPreview': '预览',
  'projectSettings.detail.priority': '项目优先级',
  'projectSettings.detail.cnName': '项目名称',
  'projectSettings.detail.name': '英文名称',
  'projectSettings.detail.identifier': '项目标识',
  'projectSettings.detail.prefix': '项目简称',
  'projectSettings.detail.group': '项目分组',
  'projectSettings.detail.group.none': '未分组',
  'projectSettings.detail.group.loadError': '项目分组加载失败，请稍后重试',
  'projectSettings.detail.tags': '项目标签',
  'projectSettings.detail.status': '项目状态',
  'projectSettings.detail.status.initiation': '立项',
  'projectSettings.detail.status.requirements': '需求分析',
  'projectSettings.detail.status.design': '设计中',
  'projectSettings.detail.status.development': '开发中',
  'projectSettings.detail.status.testing': '测试中',
  'projectSettings.detail.status.launched': '已上线',
  'projectSettings.detail.status.maintenance': '维护中',
  'projectSettings.detail.priority.low': '低',
  'projectSettings.detail.priority.medium': '中',
  'projectSettings.detail.priority.high': '高',
  'projectSettings.detail.priority.urgent': '紧急',
  'projectSettings.detail.logo': '项目 Logo 地址',
  'projectSettings.detail.updatedAt': '最近更新',
  'projectSettings.detail.description': '项目描述',
  'projectSettings.detail.empty': '未填写',
  'projectSettings.detail.editTitle': '修改项目详情',
  'projectSettings.detail.save': '保存',
  'projectSettings.detail.cancel': '取消',
  'projectSettings.detail.cnNameRequired': '请输入项目名称',
  'projectSettings.detail.identifierRequired': '请输入项目标识',
  'projectSettings.detail.identifierExists': '项目标识已存在',
  'projectSettings.detail.saveSuccess': '项目详情已更新',
  'projectSettings.detail.saveError': '项目详情更新失败，请稍后重试',
  'projectSettings.detail.previewHint':
    '当前为预览状态，点击“修改项目”即可直接编辑。',
  'projectSettings.detail.editingHint': '正在编辑项目详情，完成后请保存修改。',
  'projectSettings.detail.discardTitle': '放弃未保存的修改？',
  'projectSettings.detail.discardContent':
    '当前修改尚未保存，离开编辑状态后将无法恢复。',
  'projectSettings.detail.discard': '放弃修改',
  'projectSettings.detail.continueEditing': '继续编辑',
};
